/* ==========================================================================
   OliveDrab — recommendations
   Fetches the section from Shopify's recommendations endpoint once it is in
   view, so it never blocks the first paint of the product page. If the fetch
   fails the section simply stays empty rather than showing an error.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function load(root) {
    if (root.dataset.odLoaded) return;
    root.dataset.odLoaded = '1';

    // already rendered server side
    if (root.querySelector('[data-od-rail], .od-plist')) return;

    var base = root.dataset.url || '/recommendations/products';
    var url = base +
      '?product_id=' + encodeURIComponent(root.dataset.productId) +
      '&limit=' + encodeURIComponent(root.dataset.limit || 8) +
      '&intent=' + encodeURIComponent(root.dataset.intent || 'related') +
      '&section_id=' + encodeURIComponent(root.dataset.sectionId);

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Recommendations failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-od-recs]');
        if (!incoming || !incoming.innerHTML.trim()) return;
        root.innerHTML = incoming.innerHTML;

        if (window.OD && window.OD.initRails) window.OD.initRails(root);
        if (window.OD && window.OD.refresh) window.OD.refresh(root);
        if (window.OD && window.OD.initWishlist) window.OD.initWishlist(root);
      })
      .catch(function () { /* leave the section empty */ });
  }

  function init(ctx) {
    var items = $$('[data-od-recs]', ctx || document);
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(load);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
